import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { analyticsConsentKey, removeAnalyticsCookies } from '../lib/analytics.js'
import { measurementId, trackPageView, updateGoogleAnalyticsConsent } from '../lib/googleAnalytics.js'

export default function AnalyticsConsent() {
  const { t } = useTranslation('common')
  const [consent, setConsent] = useState(() => measurementId ? window.localStorage.getItem(analyticsConsentKey) : null)
  useEffect(() => { if (consent) updateGoogleAnalyticsConsent(consent === 'accepted') }, [consent])
  useEffect(() => {
    const showConsentChoices = () => setConsent(null)
    window.addEventListener('ncg:analytics-consent-reset', showConsentChoices)
    return () => window.removeEventListener('ncg:analytics-consent-reset', showConsentChoices)
  }, [])
  if (!measurementId || consent) return null
  const setAnalyticsConsent = (value) => {
    window.localStorage.setItem(analyticsConsentKey, value)
    updateGoogleAnalyticsConsent(value === 'accepted')
    if (value === 'declined') removeAnalyticsCookies()
    if (value === 'accepted') trackPageView()
    setConsent(value)
  }
  return <aside className="analytics-consent" aria-label={t('analytics.ariaLabel')}><p><strong>{t('analytics.title')}</strong><span>{t('analytics.description')}</span></p><div><button type="button" onClick={() => setAnalyticsConsent('declined')}>{t('analytics.decline')}</button><button type="button" onClick={() => setAnalyticsConsent('accepted')}>{t('analytics.accept')}</button></div></aside>
}
